import { LINKS } from '@/Module/Core/Constant';
interface IProps {
  seoUrlSlug: string;
  seoTitle: string;
}
const gradeMappings: {
  [key: string]: string;
} = {
  'اول ابتدایی': 'ابتدایی-پایه-اول',
  'دوم ابتدایی': 'ابتدایی-پایه-دوم',
  'سوم ابتدایی': 'ابتدایی-پایه-سوم',
  'چهارم ابتدایی': 'ابتدایی-پایه-چهارم',
  'پنجم ابتدایی': 'ابتدایی-پایه-پنجم',
  'تیزهوشان ششم': 'تیزهوشان-پایه-ششم',
  ششم: 'ابتدایی-پایه-ششم',
  هفتم: 'متوسطه-اول-پایه-هفتم',
  هشتم: 'متوسطه-اول-پایه-هشتم',
  'تیزهوشان نهم': 'تیزهوشان-پایه-نهم',
  نهم: 'متوسطه-اول-پایه-نهم'
};
const examMappings: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  ریاضی: {
    یازدهم: 'امتحان-نهایی-پایه-یازدهم-ریاضی-فیزیک',
    دوازدهم: 'امتحان-نهایی-پایه-دوازدهم-ریاضی-فیزیک',
    دهم: 'امتحان-نهایی-پایه-دهم-ریاضی-فیزیک'
  },
  تجربی: {
    یازدهم: 'امتحان-نهایی-پایه-یازدهم-علوم-تجربی',
    دوازدهم: 'امتحان-نهایی-پایه-دوازدهم-علوم-تجربی',
    دهم: 'امتحان-نهایی-پایه-دهم-علوم-تجربی'
  },
  انسانی: {
    یازدهم: 'امتحان-نهایی-پایه-یازدهم-علوم-انسانی',
    دوازدهم: 'امتحان-نهایی-پایه-دوازدهم-علوم-انسانی',
    دهم: 'امتحان-نهایی-پایه-دهم-علوم-انسانی'
  }
};
const subjectMappings: {
  [key: string]: {
    [key: string]: string;
  };
} = {
  'ریاضی و فیزیک': {
    'یازدهم کنکور': 'کنکور-پایه-یازدهم-ریاضی-فیزیک',
    یازدهم: 'متوسطه-دوم-پایه-یازدهم-ریاضی-فیزیک',
    'دوازدهم کنکور': 'کنکور-پایه-دوازدهم-ریاضی-فیزیک',
    دوازدهم: 'متوسطه-دوم-پایه-دوازدهم-ریاضی-فیزیک',
    'دهم کنکور': 'کنکور-پایه-دهم-ریاضی-فیزیک',
    دهم: 'متوسطه-دوم-پایه-دهم-ریاضی-فیزیک'
  },
  تجربی: {
    'یازدهم کنکور': 'کنکور-پایه-یازدهم-علوم-تجربی',
    یازدهم: 'متوسطه-دوم-پایه-یازدهم-علوم-تجربی',
    'دوازدهم کنکور': 'کنکور-پایه-دوازدهم-علوم-تجربی',
    دوازدهم: 'متوسطه-دوم-پایه-دوازدهم-علوم-تجربی',
    'دهم کنکور': 'کنکور-پایه-دهم-علوم-تجربی',
    دهم: 'متوسطه-دوم-پایه-دهم-علوم-تجربی'
  },
  انسانی: {
    'یازدهم کنکور': 'کنکور-پایه-یازدهم-علوم-انسانی',
    یازدهم: 'متوسطه-دوم-پایه-یازدهم-علوم-انسانی',
    'دوازدهم کنکور': 'کنکور-پایه-دوازدهم-علوم-انسانی',
    دوازدهم: 'متوسطه-دوم-پایه-دوازدهم-علوم-انسانی',
    'دهم کنکور': 'کنکور-پایه-دهم-علوم-انسانی',
    دهم: 'متوسطه-دوم-پایه-دهم-علوم-انسانی'
  }
};
export const prepareLinkLesson = ({
  seoUrlSlug,
  seoTitle
}: IProps) => {
  if (seoTitle.includes('امتحان نهایی')) {
    for (const [subject, grades] of Object.entries(examMappings)) {
      if (seoTitle.includes(subject)) {
        for (const [grade, link] of Object.entries(grades)) {
          if (seoTitle.includes(grade)) return LINKS.LESSON.replace('[gradeSlug]', link).replace('[lessonSlug]', seoUrlSlug);
        }
      }
    }
  }
  for (const [key, value] of Object.entries(gradeMappings)) {
    if (seoTitle.includes(key)) return LINKS.LESSON.replace('[gradeSlug]', value).replace('[lessonSlug]', seoUrlSlug);
  }
  for (const [subject, grades] of Object.entries(subjectMappings)) {
    if (seoTitle.includes(subject)) {
      for (const [grade, link] of Object.entries(grades)) {
        if (seoTitle.includes(grade)) return LINKS.LESSON.replace('[gradeSlug]', link).replace('[lessonSlug]', seoUrlSlug);
      }
    }
  }
  return LINKS.LESSON.replace('[gradeSlug]', '').replace('[lessonSlug]', '');
};